import { render, staticRenderFns } from "./DataDetail.vue?vue&type=template&id=7acffa0a"
import script from "./DataDetail.vue?vue&type=script&lang=js"
export * from "./DataDetail.vue?vue&type=script&lang=js"
import style0 from "./DataDetail.vue?vue&type=style&index=0&id=7acffa0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports